import React from 'react';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import GridCheckBox from '../../../../Components/Ui/GridCheckBox/GridCheckBox';
import CustomHeader from '../../../../Components/AgGrid/CustomHeader';

export const getColumnDefs1 = (props) => {
  /** Utility.GetCodeInfo — 확장(다른 그룹 콤보 등) 시 사용 */
  void props.codeList;

  const groupValues = (props.groupCdList || [])
    .map((g) => g.groupCd ?? g.GroupCd ?? '')
    .filter((s) => String(s).trim() !== '');

  return [
    {
      field: 'no',
      headerName: 'NO',
      maxWidth: 100,
      cellStyle: {
        textAlign: 'right',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      editable: false,
      cellClass: 'delete-action-cell',
      cellRenderer: (params) => (
        <GridCheckBox
          params={params}
          DeleteNewRow={props.DeleteNewRow}
          RestoreRow={props.RestoreRow}
          gridRef={props.gridRef}
          rowData={props.rowData}
          selectedRowNosRef={props.selectedRowNosRef}
          lastCheckedIndexRef={props.lastCheckedIndexRef}
          handleRowSelection={props.handleRowSelection}
        />
      ),
    },
    {
      field: 'groupCd',
      headerName:
        props.lanList?.length > 0
          ? props.lanList.find(
              (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'GROUP_CD'
            )?.LAN_NM ?? '그룹코드'
          : '그룹코드',
      headerComponent: CustomHeader,
      headerComponentParams: { required: true },
      minWidth: 120,
      editable: (params) => GridFunctions.isCellEditable(params),
      cellEditor: groupValues.length > 0 ? 'agSelectCellEditor' : undefined,
      cellEditorParams:
        groupValues.length > 0 ? { values: groupValues } : undefined,
      mobileData: 'title',
    },
    {
      field: 'code',
      headerName:
        props.lanList?.length > 0
          ? props.lanList.find(
              (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'CODE'
            )?.LAN_NM ?? '코드'
          : '코드',
      headerComponent: CustomHeader,
      headerComponentParams: { required: true },
      minWidth: 120,
      editable: (params) => GridFunctions.isCellEditable(params),
      mobileData: 'subtitle',
    },
    {
      field: 'codeNm',
      headerName:
        props.lanList?.length > 0
          ? props.lanList.find(
              (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'CODE_NM'
            )?.LAN_NM ?? '코드명'
          : '코드명',
      headerComponent: CustomHeader,
      headerComponentParams: { required: true },
      minWidth: 350,
      flex: 1,
      mobileData: 'subtitle',
    },
    {
      field: 'val1',
      headerName:
        props.lanList?.length > 0
          ? props.lanList.find(
              (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'VAL1'
            )?.LAN_NM ?? '값1'
          : '값1',
      minWidth: 120,
    },
    {
      field: 'val2',
      headerName:
        props.lanList?.length > 0
          ? props.lanList.find(
              (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'VAL2'
            )?.LAN_NM ?? '값2'
          : '값2',
      minWidth: 120,
    },
    {
      field: 'val3',
      headerName:
        props.lanList?.length > 0
          ? props.lanList.find(
              (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'VAL3'
            )?.LAN_NM ?? '값3'
          : '값3',
      minWidth: 120,
    },
    {
      field: 'ref1',
      headerName:
        props.lanList?.length > 0
          ? props.lanList.find(
              (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'REF1'
            )?.LAN_NM ?? '참조1'
          : '참조1',
      minWidth: 120,
    },
    {
      field: 'ref2',
      headerName:
        props.lanList?.length > 0
          ? props.lanList.find(
              (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'REF2'
            )?.LAN_NM ?? '참조2'
          : '참조2',
      minWidth: 120,
    },
    {
      field: 'ref3',
      headerName:
        props.lanList?.length > 0
          ? props.lanList.find(
              (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'REF3'
            )?.LAN_NM ?? '참조3'
          : '참조3',
      minWidth: 120,
    },
  ];
};
